import {Production} from '../production';

export function toString(this: Production) {
    return `Production: ${this.deal_id}`;
}
